import { Stack, Typography } from '@mui/material';
import './SatisfactionLevelSelector.scss';
import { getSatisfactionIcon } from '../../../../constants';
import clsx from 'clsx';
import { FC } from 'react';
import dayjs from 'dayjs';
import { EMASatisfactionType } from '@demind-inc/core';
import { useTranslation } from 'react-i18next';
import { formatDataDate } from '../../../../i18n';

interface SatisfactionLevelSelectorProps {
  selectedSatisfaction: EMASatisfactionType;
  onSatisfactionChange: (date: string, satisfaction: EMASatisfactionType) => void;
  satisfactionOptions: EMASatisfactionType[];
  currentDate: string;
}

const SatisfactionLevelSelector: FC<SatisfactionLevelSelectorProps> = ({
  selectedSatisfaction,
  onSatisfactionChange,
  satisfactionOptions,
  currentDate,
}) => {
  const { t, i18n } = useTranslation();
  const isFutureDate = dayjs(currentDate).isAfter(dayjs());
  function getRelativeDayLabel(date) {
    const today = dayjs();
    const target = dayjs(date);

    if (target.isSame(today, 'day')) return t('data.common.todayLower');
    if (target.isSame(today.subtract(1, 'day'), 'day')) return t('data.common.yesterdayLower');
    return formatDataDate(i18n.language, target.toDate(), {
      month: 'short',
      day: '2-digit',
    });
  }
  return (
    <Stack
      py={2}
      borderRadius={4}
      px={1.5}
      className="satisfaction-level-selector"
      direction="row"
      gap={0.25}
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" gap={0.75} flex={1}>
        {satisfactionOptions.map((option) => {
          const isSelected = selectedSatisfaction === option;

          return (
            <button
              key={option}
              className={clsx('satisfaction-level-selector__option', {
                selected: isSelected,
                disabled: isFutureDate,
              })}
              onClick={() => onSatisfactionChange(currentDate, option)}
              disabled={isFutureDate}
            >
              {getSatisfactionIcon(
                option,
                isSelected ? 'selected' : 'unselected',
                20,
                'satisfaction-level-selector__option__icon'
              )}
            </button>
          );
        })}
      </Stack>
      <Typography variant="body1" className="satisfaction-level-selector__title">
        {t('data.satisfaction.chooseLevel', { date: getRelativeDayLabel(currentDate) })}
      </Typography>
    </Stack>
  );
};

export default SatisfactionLevelSelector;
